<template>
  <div class="kk_number-format">
    <format-item v-for="(format, index) in formatList" :key="index" :format="format" />
  </div>
</template>
<script>
import FormatItem from "./FormatItem.vue";
import { icons } from "../../../../utils/icons";
import { NumberFormats } from "../../../../utils/DataTypeUtils";
export default {
  components: { FormatItem },
  data() {
    return {
      formatList: [
        {
          text: "General",
          type: NumberFormats.General,
          icon: icons.General,
        },
        {
          text: "Number",
          type: NumberFormats.Number,
          icon: icons.Number,
        },
        {
          text: "Currency",
          type: NumberFormats.Currency,
          icon: icons.Currency,
        },
        {
          text: "Short Date",
          type: NumberFormats.ShortDate,
          icon: icons.ShortDate,
        },
        {
          text: "Long Date",
          type: NumberFormats.LongDate,
          icon: icons.LongDate,
        },
        {
          text: "Time",
          type: NumberFormats.Time,
          icon: icons.Time,
        },
        {
          text: "Fraction",
          type: NumberFormats.Fraction,
          icon: icons.Fraction,
        },
        {
          text: "Text",
          type: NumberFormats.Text,
          icon: icons.Text,
        },
        {
          text: "Percentage",
          type: NumberFormats.Percentage,
          icon: icons.Percentage,
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.kk_number-format {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}
</style>
